<div #element class="custom-dropdown-component {{className}}" [style]="(show)?'display:block':'display:none'">
  <ng-content select=".app-custom-dropdown-content"></ng-content>
  <ng-content select=".app-custom-dropdown-header"></ng-content>
  <ng-content select=".app-custom-dropdown-body"></ng-content>
  <ng-content select=".app-custom-dropdown-footer"></ng-content>
</div>

